import React from 'react';

import { $gt } from '@/common/appCtx';

import { BatchImportSummary } from '../../type';
import style from './index.module.less';

export default function Summary(props: BatchImportSummary) {
  const { total_cnt: total, fail_cnt: failed, success_cnt: succeeded } = props;
  return (
    <div className={style.batchImportSummary}>
      <span className={style.total}>
        <span className={style.name}>{$gt('Total Item')}:</span>
        <span className={style.value}>{total === undefined ? '-' : total.toLocaleString()}</span>
      </span>
      <span className={style.success}>
        <span className={style.name}>{$gt('Succeeded')}:</span>
        <span className={style.value}>{succeeded === undefined ? '-' : succeeded.toLocaleString()}</span>
      </span>
      <span className={style.fail}>
        <span className={style.name}>{$gt('Failed')}:</span>
        <span className={style.value}>{failed === undefined ? '-' : failed.toLocaleString()}</span>
      </span>
    </div>
  );
}
